import React, { useState, useEffect, useLayoutEffect } from 'react';
import Footer from '../component/Footer'
import baseURL from '../component/baseURL';
import showNotification from '../component/Notification';
import stringsoflanguages from '../component/stringsoflanguages';

export default function MyActiveFeedSidebar({ activeItem, setActiveItem }) {

    const [userID, setUserID] = useState(null);
    const [Feed1Count, setFeed1Count] = useState(0);
    const [Feed2Count, setFeed2Count] = useState(0);
    const [Feed3Count, setFeed3Count] = useState(0);
    const [Feed4Count, setFeed4Count] = useState(0);
    const [Feed5Count, setFeed5Count] = useState(0);
    const [PocketFeedCount, setPocketFeedCount] = useState(0);
    const [sidebarEnter, setSidebarEnter] = useState(
        () =>
            typeof window !== 'undefined' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    useLayoutEffect(() => {
        if (sidebarEnter) return;
        let raf2;
        let startTimer;
        const raf1 = requestAnimationFrame(() => {
            raf2 = requestAnimationFrame(() => {
                startTimer = window.setTimeout(() => setSidebarEnter(true), 160);
            });
        });
        return () => {
            cancelAnimationFrame(raf1);
            if (raf2) cancelAnimationFrame(raf2);
            if (startTimer) clearTimeout(startTimer);
        };
    }, [sidebarEnter]);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        fetchFeed1(userid);
        fetchFeed2(userid);
        fetchFeed3(userid);
        fetchFeed4(userid);
        fetchFeed5(userid);
        fetchPocketFeed(userid);
    }, []);

    function fetchFeed1(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "1");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");

        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setFeed1Count(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    function fetchFeed2(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "2");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setFeed2Count(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    function fetchFeed3(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "3");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setFeed3Count(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    function fetchFeed4(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "4");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setFeed4Count(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    function fetchFeed5(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "5");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setFeed5Count(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    function fetchPocketFeed(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("feed_type", "6");
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/view_feed_by_type', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    const portfolioArray =
                        responseJson?.response?.result?.portfolio_array;

                    const count = Array.isArray(portfolioArray) ? portfolioArray.length : 0;
                    setPocketFeedCount(count);
                } else {

                    showNotification('Error', responseJson.server?.message || 'Something went wrong while fetching feed', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching feed', 'danger');
            });
    }

    return (
        <div
            className={`content-left main-sidebar${sidebarEnter ? ' main-sidebar--visible' : ''}`}
        >
            <ul>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Feed 1" ? "active" : ""}`}
                        onClick={() => setActiveItem("Feed 1")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{Feed1Count}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 16.125C11.5858 16.125 11.25 15.7892 11.25 15.375V12.75H8.625C8.21078 12.75 7.875 12.4142 7.875 12C7.875 11.5858 8.21078 11.25 8.625 11.25H11.25V8.625C11.25 8.21078 11.5858 7.875 12 7.875C12.4142 7.875 12.75 8.21078 12.75 8.625V11.25H15.375C15.7892 11.25 16.125 11.5858 16.125 12C16.125 12.4142 15.7892 12.75 15.375 12.75H12.75V15.375C12.75 15.7892 12.4142 16.125 12 16.125Z" fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 0.75C3.43629 0.75 0.75 3.43629 0.75 6.75V17.25C0.75 20.5637 3.43629 23.25 6.75 23.25H17.25C20.5637 23.25 23.25 20.5637 23.25 17.25V7.72774C23.25 6.89621 22.9049 6.10196 22.2969 5.53459L18.0351 1.55683C17.4796 1.03836 16.748 0.75 15.9881 0.75H6.75ZM2.25 6.75C2.25 4.26472 4.26472 2.25 6.75 2.25H15.75V4.5C15.75 6.15686 17.0931 7.5 18.75 7.5H21.7326C21.7441 7.57489 21.75 7.65101 21.75 7.72774V17.25C21.75 19.7353 19.7353 21.75 17.25 21.75H6.75C4.26472 21.75 2.25 19.7353 2.25 17.25V6.75ZM17.25 4.5V2.87591L20.5972 6H18.75C17.9216 6 17.25 5.32841 17.25 4.5Z" fill="white" />
                                </svg>
                            </span>
                            Feed 1
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Feed 2" ? "active" : ""}`}
                        onClick={() => setActiveItem("Feed 2")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{Feed2Count}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_620_6028)">
                                        <path d="M14.4554 11.1097C14.2519 10.9062 13.9211 10.9062 13.7176 11.1097L12.5218 12.3055V1.04324C12.5218 0.75524 12.288 0.521484 12 0.521484C11.712 0.521484 11.4783 0.75524 11.4783 1.04324V13.565C11.4783 13.7757 11.6056 13.9667 11.8007 14.0471C11.8654 14.0742 11.9332 14.0867 12 14.0867C12.1357 14.0867 12.2692 14.0335 12.3684 13.9344L14.4554 11.8474C14.6588 11.644 14.6588 11.3132 14.4554 11.1097Z" fill="white" />
                                        <path d="M12.3684 13.1971L10.2815 11.1101C10.078 10.9067 9.7472 10.9067 9.54372 11.1101C9.34024 11.3136 9.34024 11.6444 9.54372 11.8479L11.6307 13.9349C11.733 14.0361 11.8665 14.0872 12.0001 14.0872C12.1337 14.0872 12.2672 14.0361 12.3684 13.9349C12.5719 13.7313 12.5719 13.4006 12.3684 13.1971Z" fill="white" />
                                        <path d="M23.3864 11.9657L19.6247 6.32255C18.9454 5.30413 17.809 4.6958 16.5861 4.6958H14.0869C13.7989 4.6958 13.5652 4.92956 13.5652 5.21756C13.5652 5.50556 13.7989 5.73931 14.0869 5.73931H16.5861C17.4594 5.73931 18.2713 6.17341 18.7565 6.9007L22.5182 12.5438C22.8052 12.9737 22.9565 13.4746 22.9565 13.9911V20.8697C22.9565 21.7327 22.2542 22.4349 21.3913 22.4349H2.60868C1.74571 22.4349 1.04346 21.7327 1.04346 20.8697V14.0683C1.04346 13.5101 1.21774 12.9768 1.56311 12.5041L4.93772 7.38274C5.616 6.35283 6.7565 5.73926 7.98779 5.73926H9.913C10.201 5.73926 10.4348 5.50551 10.4348 5.21751C10.4348 4.92951 10.2011 4.6958 9.91305 4.6958H7.98784C6.40384 4.6958 4.93777 5.4857 4.06643 6.80884L0.706451 11.9093C0.244174 12.5407 0 13.2867 0 14.0683V20.8697C0 22.3076 1.17078 23.4784 2.60868 23.4784H21.3913C22.8292 23.4784 24 22.3076 24 20.8697V13.9911C24 13.268 23.7882 12.5678 23.3864 11.9657Z" fill="white" />
                                        <path d="M22.9565 13.0435H20.3478C18.9099 13.0435 17.7392 14.2142 17.7392 15.6521C17.7392 16.5151 17.0369 17.2174 16.1739 17.2174H7.8261C6.96313 17.2174 6.26089 16.5151 6.26089 15.6521C6.26089 14.2142 5.09011 13.0435 3.65221 13.0435H1.04348C0.755484 13.0435 0.521729 13.2772 0.521729 13.5652C0.521729 13.8532 0.755484 14.0869 1.04348 14.0869H3.65216C4.51513 14.0869 5.21738 14.7892 5.21738 15.6521C5.21738 17.09 6.38816 18.2608 7.82606 18.2608H16.1739C17.6118 18.2608 18.7826 17.09 18.7826 15.6521C18.7826 14.7892 19.4849 14.0869 20.3478 14.0869H22.9565C23.2445 14.0869 23.4783 13.8532 23.4783 13.5652C23.4783 13.2772 23.2445 13.0435 22.9565 13.0435Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_620_6028">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            Feed 2
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Feed 3" ? "active" : ""}`}
                        onClick={() => setActiveItem("Feed 3")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{Feed3Count}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21 7.25V16.75C20.9987 17.8768 20.5505 18.957 19.7537 19.7537C18.957 20.5505 17.8768 20.9987 16.75 21H7.25C6.12324 20.9987 5.043 20.5505 4.24626 19.7537C3.44951 18.957 3.00132 17.8768 3 16.75V7.25C3.00132 6.12324 3.44951 5.043 4.24626 4.24626C5.043 3.44951 6.12324 3.00132 7.25 3H8C8.13261 3 8.25979 3.05268 8.35355 3.14645C8.44732 3.24021 8.5 3.36739 8.5 3.5C8.5 3.63261 8.44732 3.75979 8.35355 3.85355C8.25979 3.94732 8.13261 4 8 4H7.25C6.38845 4.00132 5.56257 4.34416 4.95336 4.95336C4.34416 5.56257 4.00132 6.38845 4 7.25V16.75C4.00132 17.6115 4.34416 18.4374 4.95336 19.0466C5.56257 19.6558 6.38845 19.9987 7.25 20H16.75C17.6115 19.9987 18.4374 19.6558 19.0466 19.0466C19.6558 18.4374 19.9987 17.6115 20 16.75V7.25C19.9987 6.38845 19.6558 5.56257 19.0466 4.95336C18.4374 4.34416 17.6115 4.00132 16.75 4H14.5C13.9696 4 13.4609 4.21071 13.0858 4.58579C12.7107 4.96086 12.5 5.46957 12.5 6V12.795L15.645 9.645C15.7392 9.55085 15.8668 9.49795 16 9.49795C16.1332 9.49795 16.2608 9.55085 16.355 9.645C16.4492 9.73915 16.502 9.86685 16.502 10C16.502 10.1332 16.4492 10.2608 16.355 10.355L12.355 14.355C12.3074 14.4005 12.2514 14.4362 12.19 14.46C12.1301 14.4865 12.0654 14.5001 12 14.5001C11.9346 14.5001 11.8699 14.4865 11.81 14.46C11.7486 14.4362 11.6926 14.4005 11.645 14.355L7.645 10.355C7.55085 10.2608 7.49795 10.1332 7.49795 10C7.49795 9.86685 7.55085 9.73915 7.645 9.645C7.73915 9.55085 7.86685 9.49795 8 9.49795C8.13315 9.49795 8.26085 9.55085 8.355 9.645L11.5 12.795V6C11.5 5.20435 11.8161 4.44129 12.3787 3.87868C12.9413 3.31607 13.7044 3 14.5 3H16.75C17.8768 3.00132 18.957 3.44951 19.7537 4.24626C20.5505 5.043 20.9987 6.12324 21 7.25Z" fill="white" />
                                </svg>
                            </span>
                            Feed 3
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Feed 4" ? "active" : ""}`}
                        onClick={() => setActiveItem("Feed 4")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{Feed4Count}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_620_6011)">
                                        <path d="M23.7307 0.567188C23.467 0.201422 23.0444 0 22.5406 0C22.304 0 22.0504 0.0445781 21.787 0.132469L1.37627 6.936C0.671267 7.17098 0.185361 7.65122 0.0430953 8.25366C-0.0991704 8.85614 0.120626 9.50311 0.646142 10.0288C0.697517 10.0802 0.75658 10.1233 0.821173 10.1566L9.41435 14.5862L13.8441 23.1794C13.8774 23.244 13.9205 23.303 13.9719 23.3544C14.3942 23.7767 14.8812 24 15.3804 24H15.3805C16.1365 24 16.7819 23.4728 17.0646 22.6243L23.8683 2.21367C24.0822 1.57177 24.0333 0.987047 23.7307 0.567188ZM1.4117 8.57686C1.43861 8.46281 1.59545 8.3453 1.82092 8.27011L21.1937 1.81252L9.80224 13.2039L1.5738 8.96245C1.44986 8.81761 1.3886 8.67474 1.4117 8.57686ZM15.7305 22.1797C15.6638 22.3799 15.5368 22.5938 15.3805 22.5938C15.2859 22.5938 15.1619 22.5325 15.0382 22.4267L10.7966 14.1983L22.1883 2.80659L15.7305 22.1797Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_620_6011">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            Feed 4
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Feed 5" ? "active" : ""}`}
                        onClick={() => setActiveItem("Feed 5")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{PocketFeedCount}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M6.75 0.75C3.8505 0.75 1.5 3.1005 1.5 6V18C1.5 20.8995 3.8505 23.25 6.75 23.25H12.9188C12.4788 22.8346 12.1302 22.3235 11.9062 21.75H6.75C4.67895 21.75 3 20.0711 3 18V6C3 3.92895 4.67895 2.25 6.75 2.25H15C17.071 2.25 18.75 3.92895 18.75 6V12.375H19.5C19.7561 12.375 20.0068 12.3983 20.25 12.443V6C20.25 3.1005 17.8995 0.75 15 0.75H6.75Z" fill="white" />
                                    <path d="M5.625 8.25C5.625 7.83578 5.96078 7.5 6.375 7.5H11.625C12.0392 7.5 12.375 7.83578 12.375 8.25C12.375 8.66422 12.0392 9 11.625 9H6.375C5.96078 9 5.625 8.66422 5.625 8.25Z" fill="white" />
                                    <path d="M5.625 11.25C5.625 10.8358 5.96078 10.5 6.375 10.5H15.375C15.7892 10.5 16.125 10.8358 16.125 11.25C16.125 11.6642 15.7892 12 15.375 12H6.375C5.96078 12 5.625 11.6642 5.625 11.25Z" fill="white" />
                                    <path d="M19.7216 17.7046C19.9726 17.3751 19.909 16.9045 19.5796 16.6535C19.2501 16.4024 18.7795 16.466 18.5284 16.7955L17.1015 18.6684L16.7034 18.1861C16.4398 17.8666 15.967 17.8214 15.6476 18.0851C15.3281 18.3488 15.2829 18.8215 15.5466 19.1409L16.5466 20.3525C16.6923 20.529 16.9107 20.6294 17.1396 20.6249C17.3685 20.6204 17.5828 20.5117 17.7216 20.3296L19.7216 17.7046Z" fill="white" />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 13.5C14.0931 13.5 12.75 14.8431 12.75 16.5V20.25C12.75 21.9069 14.0931 23.25 15.75 23.25H19.5C21.1569 23.25 22.5 21.9069 22.5 20.25V16.5C22.5 14.8431 21.1569 13.5 19.5 13.5H15.75ZM14.25 16.5C14.25 15.6716 14.9216 15 15.75 15H19.5C20.3284 15 21 15.6716 21 16.5V20.25C21 21.0784 20.3284 21.75 19.5 21.75H15.75C14.9216 21.75 14.25 21.0784 14.25 20.25V16.5Z" fill="white" />
                                </svg>
                            </span>
                            Feed 5
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
                <li>
                    <div
                        className={`nav-item ${activeItem === "Pocket Feed" ? "active" : ""}`}
                        onClick={() => setActiveItem("Pocket Feed")}
                    >
                        <div className="nav-item-icon">
                            <span className="nav-item-icon-count">{Feed5Count}</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M11.4868 0.973145C7.99524 0.973145 5.14697 3.83116 5.14697 7.32272C5.14697 9.4571 6.21498 11.3482 7.84033 12.4985C4.04927 14.0175 1.35986 17.7242 1.35986 22.0492C1.36566 22.3106 1.47357 22.5593 1.66047 22.7421C1.84738 22.9249 2.09843 23.0273 2.35986 23.0273C2.6213 23.0273 2.87235 22.9249 3.05925 22.7421C3.24616 22.5593 3.35406 22.3106 3.35986 22.0492C3.35986 17.4592 7.06081 13.7602 11.6509 13.7602C13.2531 13.7602 14.7404 14.217 16.0063 15.0005C16.1184 15.0701 16.2432 15.1168 16.3734 15.1382C16.5036 15.1595 16.6367 15.155 16.7652 15.1248C16.8936 15.0946 17.0149 15.0394 17.1219 14.9623C17.229 14.8852 17.3198 14.7878 17.3892 14.6755C17.4585 14.5633 17.5051 14.4384 17.5261 14.3082C17.5472 14.1779 17.5423 14.0447 17.5118 13.9164C17.4813 13.788 17.4258 13.6669 17.3485 13.56C17.2711 13.4531 17.1734 13.3625 17.061 13.2934C16.4906 12.9404 15.8714 12.664 15.2329 12.4263C16.8058 11.2701 17.8364 9.4145 17.8364 7.32272C17.8364 3.83116 14.9784 0.973145 11.4868 0.973145ZM11.4868 2.97502C13.8975 2.97502 15.8364 4.91203 15.8364 7.32272C15.8364 9.73342 13.8975 11.6626 11.4868 11.6626C9.07612 11.6626 7.14697 9.73342 7.14697 7.32272C7.14698 4.91203 9.07612 2.97502 11.4868 2.97502ZM21.6079 14.9771C21.4454 14.9817 21.2864 15.0259 21.1448 15.1059C21.0033 15.1859 20.8833 15.2992 20.7954 15.436L17.3481 20.6021L15.186 19.1547C15.0764 19.081 14.9533 19.0297 14.8238 19.0036C14.6943 18.9776 14.5609 18.9773 14.4313 19.0029C14.3016 19.0286 14.1784 19.0796 14.0685 19.1529C13.9586 19.2262 13.8643 19.3205 13.7909 19.4304C13.7175 19.5403 13.6666 19.6634 13.6409 19.793C13.6153 19.9226 13.6154 20.0561 13.6415 20.1857C13.6675 20.3152 13.7188 20.4383 13.7924 20.548C13.8661 20.6576 13.9607 20.7516 14.0708 20.8247L17.0767 22.8247C17.1862 22.8973 17.3089 22.9477 17.4379 22.9729C17.5668 22.9981 17.6995 22.9975 17.8283 22.9714C17.9571 22.9453 18.0795 22.8941 18.1884 22.8207C18.2974 22.7472 18.3908 22.653 18.4634 22.5435L22.4653 16.5416C22.5697 16.3891 22.6298 16.2106 22.6389 16.0261C22.648 15.8415 22.6059 15.658 22.5171 15.496C22.4282 15.3339 22.2963 15.1997 22.1358 15.1081C21.9753 15.0165 21.7926 14.9711 21.6079 14.9771Z" fill="white" />
                                </svg>
                            </span>
                            Pocket Feed
                        </div>
                        <span className="view-details">{stringsoflanguages.viewDetails}</span>
                    </div>
                </li>
            </ul>

            {/* <Footer /> */}
        </div>
    )
}